import axiosInstance from "./axiosInstance";

const API_URL = "/posts";

const create_post = async (formData) => {
  try {
    // Let the browser set Content-Type, including the required multipart boundary.
    const response = await axiosInstance.post(`${API_URL}/create_post`, formData);

    return response.data;
  } catch (error) {
    console.error("Error while posting", error);
    throw error;
  }
};

const analyzePostClothing = async (postId) => (await axiosInstance.post(`${API_URL}/${postId}/analyze-clothing`)).data;
const confirmPostClothing = async (postId, items) => (await axiosInstance.post(`${API_URL}/${postId}/confirm-clothing`, { items })).data;

const getPosts = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/get_posts`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const getMyPosts = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/get_my_posts`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const getFollowingUserPosts = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/get_following_user_posts`,
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const getOtherUserProfilePost = async (username) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/get_other_user_profile_post`,
      {
        params: { username },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const createLike = async (post_id, user_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/create_like`,
      {
        post_id: post_id,
        user_id: user_id,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching posts likes:", error);
    throw error;
  }
};

const deleteLike = async (post_id, user_id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/delete_like`, {
      data: { post_id: post_id, user_id: user_id },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts likes:", error);
    throw error;
  }
};

const createComment = async (values, post_id, user_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/create_comment`,
      {
        comment: values.comment,
        post_id: post_id,
        user_id: user_id,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding comment:", error);
    throw error;
  }
};

const getPostComments = async (postId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${postId}/comments`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching post comments:", error);
    throw error;
  }
};

export {
  create_post,
  getPosts,
  getMyPosts,
  getFollowingUserPosts,
  getOtherUserProfilePost,
  createLike,
  deleteLike,
  createComment,
  getPostComments,
  analyzePostClothing,
  confirmPostClothing,
};

export const getShoppingPost = async (id) => (await axiosInstance.get("/posts/" + id)).data.post;
export const getPostProducts = async (id) => (await axiosInstance.post("/posts/" + id + "/products", {}, { timeout: 180000 })).data;
